import "core-js/modules/es.array.concat";
import _defineProperty from "/Users/dfravel/Projects/degreedata-wp/wp-content/plugins/dd-search/vue/node_modules/@babel/runtime/helpers/esm/defineProperty";
import Vue from 'vue';
import { consoleWarn } from '../../util/console';

function generateWarning(child, parent) {
  return function () {
    return consoleWarn("The ".concat(child, " component must be used inside a ").concat(parent));
  };
}

export function inject(namespace, child, parent) {
  var defaultImpl = child && parent ? {
    register: generateWarning(child, parent),
    unregister: generateWarning(child, parent)
  } : null;
  return Vue.extend({
    name: 'registrable-inject',
    inject: _defineProperty({}, namespace, {
      default: defaultImpl
    })
  });
}
export function provide(namespace) {
  var self = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return Vue.extend({
    name: 'registrable-provide',
    methods: self ? {} : {
      register: null,
      unregister: null
    },
    provide: function provide() {
      return _defineProperty({}, namespace, self ? this : {
        register: this.register,
        unregister: this.unregister
      });
    }
  });
}